import { render } from "./DetailHistory.vue?vue&type=template&id=e7b0b36e"
import script from "./DetailHistory.vue?vue&type=script&lang=js"
export * from "./DetailHistory.vue?vue&type=script&lang=js"
script.render = render

export default script